import { render, staticRenderFns } from "./TypeVenteList.vue?vue&type=template&id=470f362a&scoped=true&"
import script from "./TypeVenteList.vue?vue&type=script&lang=js&"
export * from "./TypeVenteList.vue?vue&type=script&lang=js&"
import style0 from "./TypeVenteList.vue?vue&type=style&index=0&id=470f362a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f362a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('470f362a')) {
      api.createRecord('470f362a', component.options)
    } else {
      api.reload('470f362a', component.options)
    }
    module.hot.accept("./TypeVenteList.vue?vue&type=template&id=470f362a&scoped=true&", function () {
      api.rerender('470f362a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/type_vente/TypeVenteList.vue"
export default component.exports